@use "variables" as *;

.mainContainer {
  width: 100%;
  height: 100%;
  display: flex;
}

.mainDiv {
  padding: 0 $spacing-s 0 $spacing-s;
  display: flex;
  flex-grow: 1;
}

.list {
  width: 100%;
  flex-grow: 1;
  padding-top: $spacing-s !important;
}

.itemCard {
  margin: $spacing-s $spacing-s $spacing-m $spacing-s;
}

.itemCardMobile {
  margin: $spacing-s 0 $spacing-m 0;
}

.cardDiv {
  padding: $spacing-m;
}

.graphsDiv {
  padding-top: $spacing-m;
  padding-bottom: $spacing-m;
  padding-right: $spacing-s;
  margin-left: $spacing-s;
  overflow: auto !important;
}

.graphsDivMobile {
  padding-top: $spacing-m;
  padding-bottom: $spacing-m;
  overflow: auto !important;
}

.sectionTitle {
  padding-left: $spacing-l;
  font-weight: bold;
}

.resizeHandle {
  width: $spacing-m;
  display: flex;
  justify-content: center;
  outline: none !important;
}

.loadingStack {
  width: 100%;
  align-self: center;
  padding-left: 20%;
  padding-right: 20%;
  font-size: $fontSize-m;
  font-weight: bolder;
  text-align: center;
}

.progressBar {
  border-radius: 5px;
}
